module.exports = __webpack_public_path__ + "static/img/sc0.42e07d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/sc0.png
// module id = Lxnq
// module chunks = 19